module.exports = __webpack_public_path__ + "static/media/new-mock-en.1f1e4143.png";